// extracted by mini-css-extract-plugin
export default {"label_spec":"breadcrumb_label_spec__51rWm","breadcrumb":"breadcrumb_breadcrumb__GBx0x","active":"breadcrumb_active__ORYGK"};